import * as React from "react";
import { Formik, Form, Field } from "formik";
import { SourceCodeEditor } from "components/common";
import { Button, ControlLabel, HelpBlock } from "components/bootstrap";
import {
  DEFAULT_BODY_TEMPLATE,
  DEFAULT_HTML_BODY_TEMPLATE
} from "components/event-notifications/event-notification-types/emailNotificationTemplates";
import usePermissions from "hooks/usePermissions";
import useEmailTemplates from "./useEmailTemplate";
const DEFAULT_CONFIG = {
  override_defaults: false,
  text_body: DEFAULT_BODY_TEMPLATE,
  html_body: DEFAULT_HTML_BODY_TEMPLATE
};
const EmailTemplateConfiguration = () => {
  var _a, _b, _c;
  const { isPermitted } = usePermissions();
  const { templateConfig, onUpdateEmailTemplates } = useEmailTemplates();
  const updateEmailTemplates = (values) => onUpdateEmailTemplates(values);
  const isDisabled = !isPermitted("email_notification_defaults:update");
  const initialValues = {
    override_defaults: (_a = templateConfig == null ? void 0 : templateConfig.override_defaults) != null ? _a : DEFAULT_CONFIG.override_defaults,
    text_body: (_b = templateConfig == null ? void 0 : templateConfig.text_body) != null ? _b : DEFAULT_CONFIG.text_body,
    html_body: (_c = templateConfig == null ? void 0 : templateConfig.html_body) != null ? _c : DEFAULT_CONFIG.html_body
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: updateEmailTemplates, enableReinitialize: true }, ({ dirty, handleSubmit, setFieldValue }) => /* @__PURE__ */ React.createElement(Form, { onSubmit: handleSubmit }, /* @__PURE__ */ React.createElement(Field, { name: "override_defaults" }, ({ field }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      id: "override-defaults",
      name: field.name,
      checked: !!field.value,
      onChange: (e) => setFieldValue(field.name, e.target.checked),
      disabled: isDisabled
    }
  ), "Use custom templates"), /* @__PURE__ */ React.createElement(HelpBlock, null, "When enabled, these templates will be used instead of the global defaults."))), /* @__PURE__ */ React.createElement(ControlLabel, null, "Body Template"), /* @__PURE__ */ React.createElement(Field, { name: "text_body" }, ({ field }) => {
    var _a2;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      SourceCodeEditor,
      {
        id: "body-template",
        name: field.name,
        mode: "text",
        theme: "light",
        value: (_a2 = field.value) != null ? _a2 : "",
        onChange: (val) => setFieldValue(field.name, val)
      }
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, "The template that will be used to generate the email body. You may also\xA0", /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "link",
        type: "button",
        onClick: () => {
          setFieldValue(field.name, DEFAULT_BODY_TEMPLATE);
        }
      },
      "restore the default value"
    ), "."));
  }), /* @__PURE__ */ React.createElement(ControlLabel, null, "HTML Body Template"), /* @__PURE__ */ React.createElement(Field, { name: "html_body" }, ({ field }) => {
    var _a2;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      SourceCodeEditor,
      {
        id: "html-body-template",
        name: field.name,
        mode: "text",
        theme: "light",
        value: (_a2 = field.value) != null ? _a2 : "",
        onChange: (val) => setFieldValue(field.name, val)
      }
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, "The template that will be used to generate the email HTML body. You may also\xA0", /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "link",
        type: "button",
        onClick: () => {
          setFieldValue(field.name, DEFAULT_HTML_BODY_TEMPLATE);
        }
      },
      "restore the default value"
    ), "."));
  }), !isDisabled && /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "info", type: "submit", disabled: !dirty }, "Update templates")));
};
export default EmailTemplateConfiguration;
